﻿<template>
    <!-- is-low: 1-5 seats left (is-last: 1-3), is-short: not enough seats for the passengers selected (see Availability) -->
    <div v-if="!isToday() && display_day()" class="tc-day" :class="{ 'is-full': isFull(), 'is-low': Is_Low(), 'is-last': Availability() == 'last', 'is-short': Availability() == 'short' }">
        <div v-if="hasAddOn()" class="addon-ribbon" aria-hidden="true"></div>

        <button type="button" class="tc-day-btn departures" :class="{ selected: isDate_Selected() }"
            :disabled="isFull() || Not_Enough_Seats()" :aria-pressed="isDate_Selected()" :aria-label="Day_Label()" :title="Day_Title()"
            @click="date_clicked()">
            <span class="day-label">{{getDay()}}</span>
            <span class="tc-day-price price" v-if="getPrice() != '' && !isFull()">{{getPrice()}}</span>
            <small class="tc-day-seats capacity" v-if="getSeats() != ''">{{getSeats()}}</small>
        </button>
    </div>
    <!-- a day without a departure: just its number (shown for HAG / HEX / RTG only, tour_search.css) -->
    <span v-else-if="day?.is_current_month && day?.number" class="tc-day-none" aria-hidden="true">{{ day.number }}</span>
</template>

<script lang="ts" src="./calendar_day.ts"></script>